import { render, staticRenderFns } from "./CreatorsSliderItem.vue?vue&type=template&id=be8b3034&scoped=true&"
import script from "./CreatorsSliderItem.vue?vue&type=script&lang=ts&"
export * from "./CreatorsSliderItem.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorsSliderItem.vue?vue&type=style&index=0&id=be8b3034&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8b3034",
  null
  
)

export default component.exports